<template>
  <div ref="fixedHeaderRoot" id="fixedHeaderRoot">
    <div class="common-header" :class="headerBarFixed == true ? 'isFixed' : ''">
      <!-- <h3 class="header-logo">汽车之家</h3> -->
      <div class="header-logo-wrap">
        <img class="header-logo" src="../assets/images/autologo.png" alt="汽车之家" @click="replaceMenu()">
      </div>
      <ul class="header-nav">
        <li class="header-nav-li" @click="replaceMenu()" :class="{'active': $route.path === '/'}">首页</li>
        <li class="header-nav-li" :class="{'active': $route.path === '/introAutoCloud' || $route.path === '/introAutobi'}">
          <div class="header-nav-title">
            <span>产品介绍</span>
            <span class="arrow"></span>
          </div>
          <div class="drop-menu">
            <span class="trangle"></span>
            <ul class="menu-list">
              <li class="menu-list-item" v-for="(item,index) in menulist" :key="index" @click="replaceMenu(item.href, item.pv, item.action, item.pmark)">
                {{ item.name }}
                <!-- <router-link :to="{ path: `/item.href` }">{{item.content}}</router-link> -->
              </li>
            </ul>
          </div>
        </li>
        <!-- <li class="header-nav-li" @click="replaceMenu('aboutus')">关于我们</li> -->
        <li class="header-nav-li">
          <div class="header-nav-title" @click="contactus">
            <span>联系我们</span>
            <span class="arrow"></span>
          </div>
          <div class="drop-menu concat-menu">
            <span class="trangle"></span>
            <ul class="menu-list">
              <li class="menu-list-item" v-for="(item,index) in concatlist" :key="index">
                {{ item }}
                <!-- <router-link :to="item.href">{{item.content}}</router-link> -->
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      headerBarFixed: false,
      menulist: [
        {
          id: '0',
          name: 'AutoBI',
          current: true,
          href: 'introAutobi',
          pv: 1724,
          action: 'auto_commercialize_tech_AutoBI_click',
          pmark: 2
        },
        {
          id: '1',
          name: '云平台',
          current: false,
          href: 'introAutoCloud',
          pv:1723,
          action: 'auto_commercialize_tech_cloud_click',
          pmark: 3
        },
        {
          id: '2',
          name: '推荐搜索平台',
          current: false,
          href: 'introRecommand',
          pv:1725,
          action: 'auto_commercialize_tech_search_recommendation_click',
          pmark: 4
        },
        {
          id: '3',
          name: '视频直播',
          current: false,
          href: 'introZhibo',
          pv:1726,
          action:'auto_commercialize_tech_live_click',
          pmark: 5
        },
        {
          id: '4',
          name: '推送平台',
          current: false,
          href: 'introPush',
          pv: 1722,
          action: 'auto_commercialize_tech_push_click',
          pmark: 6
        },
        {
          id: '5',
          name: '闪退采集工具',
          current: false,
          href: 'introFlashback',
          pv:1727,
          action: 'auto_commercialize_tech_Flashback_acquisition_click',
          pmark: 7
        },
        {
          id: '6',
          name: '播放器',
          current: false,
          href: 'introPlayer',
          pv:1721,
          action: 'auto_commercialize_tech_player_click',
          pmark: 8
        }
      ],
      concatlist: ['400-618-4889', 'Tech-stack@autohome.com.cn']
    }
  },
  created () {
    this.headerBarFixed = false
    window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    contactus(){
      window.pvTrack.category = 0
        sendEvent({
          site: 144,
          action:'auto_commercialize_tech_contact_click',
          area: 'top',
          element: 'details',
          pmark: 9,
        });
    },
    replaceMenu (menuHref, pv, action, pmark) {
      if (menuHref) {
        this.$router.replace(`/${menuHref}`)
        window.pvTrack.category = pv
        sendEvent({
          site: 144,
          category: window.pvTrack.category,
          action,
          area: 'top',
          element: 'details',
          pmark,
        });
      } else {
        window.pvTrack.category = 1728
        sendEvent({
          site: 144,
          category: window.pvTrack.category,
          action: 'auto_commercialize_tech_home_click',
          area: 'top',
          element: 'details',
          pmark: 1,
        });
        this.$router.replace({name: 'HomePage'})
      }
    },
    handleScroll () {
      this.$nextTick(() => {
        let offsetTop = this.$refs.fixedHeaderRoot && this.$refs.fixedHeaderRoot.getBoundingClientRect().top
        this.headerBarFixed = offsetTop < 0 ? true : false   // eslint-disable-line
      })
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped>
.main {
  overflow-x: hidden;
}
.common-header {
  width: 100%;
  height: 62px;
  line-height: 62px;
  background-color: #3A5FFF;
  color: #fff;
  /* position: sticky;
  position: -webkit-sticky;
  top: 0; */
  position: relative;
  z-index: 999;
}
.isFixed {
  position: fixed;
  top: 0;
  z-index: 999;
}
.common-header.fixed {
  position: fixed;
  top: 0;
}
.header-logo-wrap {
  float: left;
  width: 202px;
  height: 62px;
  overflow: hidden;
}
.header-logo {
  float: left;
  padding-top: 22px;
  padding-left: 65px;
  width: 202px;
  height: 80px;
  cursor: pointer;
  transform: scale(0.5);
  -webkit-transform: scale(0.5);
  -moz-transform: scale(0.5);
  -o-transform: scale(0.5);
  transform-origin: top left;
  -webkit-transform-origin: top left;
  -moz-transform-origin: top left;
  -o-transform-origin: top left;
}
.header-nav {
  float: right;
  display: inline-block;
  margin-right: 65px;
  height: 62px;
  line-height: 62px;
}
.header-nav .header-nav-li {
  position: relative;
  float: left;
  height: 62px;
  line-height: 62px;
  margin-left: 35px;
  font-family: 'PingFangSC-Regular';
  font-size: 16px;
  color: rgba(255, 255, 255, .6);
  cursor: pointer;
}
.header-nav .header-nav-li.active {
  color: #fff;
  font-family: 'PingFangSC-Semibold';
}
.header-nav .header-nav-li:hover {
  color: #fff;
  font-family: 'PingFangSC-Semibold';
}
.header-nav .header-nav-li .drop-menu {
  position: absolute;
  top: 0;
  left: -20px;
  margin-top: 45px;
  display: flex;
  flex-direction: column;
  z-index: 999;
  display: none;
}
.header-nav .header-nav-li:hover .drop-menu {
  display: flex;
  transition: display 0.6 ease-in-out;
}
.header-nav .header-nav-li .concat-menu {
  right: 0;
  left: auto;
}
.header-nav .concat-menu .menu-list-item {
  padding: 0 20px 0 10px;
}
.drop-menu .trangle {
  display: inline-block;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-bottom-color: #fff;
  position: relative;
  left: 50%;
  margin-left: -3px;
}
.concat-menu .trangle {
  left: 74%;
  margin-left: 0;
}
.header-nav .header-nav-li .menu-list {
  min-width: 110px;
  background-color: #fff;
  text-align: left;
  border-radius: 6px;
}
.header-nav .header-nav-li .concat-menu .menu-list {
  width: 288px;
  left: -50%;
}
.concat-menu .menu-list .menu-list-item {
  text-align: left;
  display: flex;
  align-items: center;
  user-select: text;
  -moz-user-select: text;
  -o-user-select: text;
  -khtml-user-select: text;
  -webkit-user-select: text;
  -ms-user-select:text;
}
.concat-menu .menu-list .menu-list-item:before {
  content: '';
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100%;
  /* zoom: 0.4; */
  transform: scale(0.5);
  -webkit-transform: scale(0.5);
  -moz-transform: scale(0.5);
  -o-transform: scale(0.5);
}
.concat-menu .menu-list .menu-list-item:nth-child(1):before {
  width: 36px;
  height: 38px;
  background-image: url('./../assets/images/_icon-phone.png');
  top: 4px;
}
.concat-menu .menu-list .menu-list-item:nth-child(2):before {
  width: 36px;
  height: 30px;
  background-image: url('./../assets/images/_icon-email.png');
}
.header-nav .header-nav-li .menu-list-item {
  line-height: 32px;
  font-size: 14px;
  color: #6F778F;
  padding: 0 15px;
  min-width: 85px;
}
.concat-menu .menu-list .menu-list-item:nth-child(1):hover:before {
  background-image: url('./../assets/images/_icon-phone-hover.png');
}
.concat-menu .menu-list .menu-list-item:nth-child(2):hover:before {
  background-image: url('./../assets/images/_icon-email-hover.png');
}
.header-nav .header-nav-li .arrow {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 9px;
  border: 5px solid transparent;
  border-top-color: rgba(255, 255, 255, .6);
  position: relative;
  top: 2px;
}
.header-nav .header-nav-li .menu-list-item:hover {
  background-color: #F0F3FF;
  color: #3A5FFF;
  border-radius: 6px;
}
.header-nav .header-nav-li:hover .header-nav-title span {
  color: #fff;
  font-family: 'PingFangSC-Semibold';
}
.header-nav .header-nav-li:hover .arrow {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 9px;
  border: 5px solid transparent;
  border-bottom-color: #fff;
  position: relative;
  top: -3px;
}
.header-nav .header-nav-li:last-child {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/mainheader.vue